import { render, staticRenderFns } from "./UserSelectorModal.vue?vue&type=template&id=46330a80&scoped=true&"
import script from "./UserSelectorModal.vue?vue&type=script&lang=js&"
export * from "./UserSelectorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46330a80",
  null
  
)

export default component.exports